import React, { useState } from 'react';
import { Plus, Place, Navigation, Info } from '@piiqtechnologies/svg-icons';
import { PeekBox, PeekButton, PeekMenu, PeekMenuItem, PeekTypography } from '@piiqtechnologies/ui-components';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import { HotspotType } from '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';

const CreateHotspotMenuItem = ({ icon, onClick, text, disabled }) => (React.createElement(PeekMenuItem, { disabled: disabled, onClick: onClick, sx: { gap: 1 } },
    icon,
    " ",
    React.createElement(PeekTypography, { color: "", variant: "h4" }, text)));
const CreateHotspotMenu = ({ onMenuItemSelection }) => {
    var _a;
    const { details } = usePannellumViewer();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleCreateHotspotMenuItemClick = (hotspotType) => {
        onMenuItemSelection(hotspotType, true);
        handleMenuClose();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekBox, null,
            React.createElement(PeekButton, { "aria-label": "create hotspot", id: "add-hotspot", color: "secondary", variant: "outlined", onClick: handleOpenMenu, startIcon: React.createElement(Plus, null) }, "Add")),
        React.createElement(PeekMenu, { id: "hotspot-menu", "aria-labelledby": "add-hotspot", anchorEl: anchorEl, open: open, onClose: handleMenuClose, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left",
            }, disablePortal: true, PaperProps: {
                sx: { mt: 1.2, ml: -1 },
            } },
            React.createElement(CreateHotspotMenuItem, { icon: React.createElement(Place, null), text: "Link to another room", disabled: ((_a = details === null || details === void 0 ? void 0 : details.nodes) === null || _a === void 0 ? void 0 : _a.length) === 1, onClick: () => handleCreateHotspotMenuItemClick(HotspotType.Node) }),
            React.createElement(CreateHotspotMenuItem, { icon: React.createElement(Navigation, null), text: "Link to another space", onClick: () => handleCreateHotspotMenuItemClick(HotspotType.Space) }),
            React.createElement(CreateHotspotMenuItem, { icon: React.createElement(Info, null), text: "InfoSpot", onClick: () => handleCreateHotspotMenuItemClick(HotspotType.Info) }))));
};

export { CreateHotspotMenu as default };
